// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.send-sms-modal .sk-modal__wrapper {\n  overflow: visible;\n}\n.send-details-modal__code .sk-select__list {\n  height: 99px;\n}\n.send-details-modal__code .sk-select {\n  width: 80px;\n}\n.send-details-modal__code .sk-select :first-child {\n  font-weight: bold;\n}\n", ""]);
// Exports
module.exports = exports;
